module.exports = __webpack_public_path__ + "static/250526_Q1-2025_Announcement_Financial_Reporting-35e4ed6f0b4506270fbdd89b9fd89daf.pdf";